import React, { useState, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CardWrap from "../Common/CardWrap";
import ResultModal from "../Common/ResultModal";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { itemGroupServices } from "../../Services";
import Tooltip from "../Common/Tooltip";
import { lettersAndNumbers } from "../../Config/Regex";

const initState = {
  name: "",
  description: "",
};

const EditItemGroup = ({ match }) => {
  const history = useHistory();
  const { t: translator } = useTranslation();

  const { locName, locTenant } = useContext(GlobalContext);
  const [backUrl, setBackUrl] = useState();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [itemGroup, setItemGroup] = useState(initState);
  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });
  const tenantId = match.params.tenantId;
  const selectedItemGroupId = match.params.itemGroupId;

  useEffect(() => {
    setBackUrl(`/${locName}/${locTenant}`);
    if (selectedItemGroupId) {
      itemGroupServices.getById(selectedItemGroupId).then((data) => {
        setItemGroup({
          itemGroupId: data.data.itemGroupId,
          name: data.data.name,
          description: data.data.description,
        });
      });
    }
  }, []);

  const onSubmit = (data) => {
    if (selectedItemGroupId) {
      itemGroupServices
        .update({
          itemGroupId: selectedItemGroupId,
          name: data.name,
          description: data.description,
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditItemGroup-Update-SuccesModal-Title"),
                text: translator("EditItemGroup-Update-SuccesModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator("EditItemGroup-Update-UnsuccesModal-Title"),
                text: translator("EditItemGroup-Update-UnsuccesModal-Text"),
                btnClass: "btn btn-primary",
                success: false,
              });
        })
        .catch((err) =>
          setResultModal({
            show: true,
            title: translator("EditItemGroup-Update-UnsuccesModal-Title"),
            text: translator("EditItemGroup-Update-UnsuccesModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          })
        );
    } else {
      itemGroupServices
        .create({
          tenantId: tenantId && Number(tenantId),
          name: data.name,
          description: data.description,
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditItemGroup-Add-SuccesModal-Title"),
                text: translator("EditItemGroup-Add-SuccesModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator("EditItemGroup-Add-UnsuccesModal-Title"),
                text: translator("EditItemGroup-Add-UnsuccesModal-Text"),
                btnClass: "btn btn-primary",
                success: false,
              });
        })
        .catch((err) =>
          setResultModal({
            show: true,
            title: translator("EditItemGroup-Add-UnsuccesModal-Title"),
            text: translator("EditItemGroup-Add-UnsuccesModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          })
        );
    }
  };

  const handleCloseResultModal = () => {
    setResultModal({ show: false });
    if (resultModal.success === true) {
      history.push(backUrl);
    }
  };

  const handleCancel = () => {
    goBack();
  };

  const goBack = () => {
    history.push(backUrl);
  };

  return (
    <CardWrap
      title={translator("EditItemGroup-Title-ItemGroupManagement")}
      subtitle={
        selectedItemGroupId
          ? translator("EditItemGroup-Subtitle-EditArticleGroup")
          : translator("EditItemGroup-Subtitle-NewArticleGroup")
      }
      backUrl={backUrl}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("EditItemGroup-Legend-GeneralData")}
            </legend>

            <div className="form-group">
              <label>{translator("EditItemGroup-Name")}</label>{" "}
              <Tooltip text={translator("EditItemGroup-Name-Msg")} />
              <input
                type="text"
                className="form-control"
                name="name"
                defaultValue={itemGroup.name}
                ref={register({
                  required: true,
                  pattern: lettersAndNumbers,
                  maxLength: 50,
                })}
              />
              {errors.name && errors.name.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.name && errors.name.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-LettersAndNumbers")}
                </p>
              )}
              {errors.name && errors.name.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength50")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("EditItemGroup-Description")}</label>{" "}
              <Tooltip text={translator("EditItemGroup-Description-Msg")} />
              <input
                type="text"
                className="form-control"
                name="description"
                defaultValue={itemGroup.description}
                ref={register({
                  required: true,
                  pattern: lettersAndNumbers,
                  maxLength: 250,
                })}
              />
              {errors.description && errors.description.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.description && errors.description.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-LettersAndNumbers")}
                </p>
              )}
              {errors.description &&
                errors.description.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength250")}
                  </p>
                )}
            </div>
          </fieldset>
        </div>

        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
          &nbsp;
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>
      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={handleCloseResultModal}
      />
    </CardWrap>
  );
};

export default EditItemGroup;
